import { isSubTreeKey } from '../../../client/components/NavigationMenu/utils';

const doesNodeContainArtifactId = (node) =>
  node.data && node.data.extra && !!node.data.extra.artifactId;

export const addArtifactIdVisitor = (node) => {
  /*
    add node artifactId to all node properties.
  */
  Object.keys(node).forEach((key) => {
    if (isSubTreeKey(key) && doesNodeContainArtifactId(node)) {
      node[key].data.extra = { artifactId: node.data.extra.artifactId };
    }
  });
  return node;
};
